export default {"src":"/_next/static/media/dream-deck.6718c83f.svg","height":29,"width":30,"blurWidth":0,"blurHeight":0};